import Icon from "../ui/Icon.jsx";

/**
 * 하루 한 번(USER_DAILY_LIMIT=1)이라 두 번째 방문은 반드시 이 화면이다.
 * 문구는 서버가 준 것을 그대로 쓴다 — 개인 상한과 전체 정원이 다른 문장이다.
 */
export default function Limit({ message = "오늘 몫을 다 쓰셨어요. 내일 다시 와주세요." }) {
  const [head, ...rest] = message.split(". ");

  return (
    <main className="screen">
      <header className="bar">
        <a className="logo" href="/">그래서요<span className="q">?</span></a>
        <span className="grow" />
        <span className="pill quiet">오늘 남은 토론 0</span>
      </header>

      <section className="card mark raised" style={{ padding: "24px 20px", borderRadius: 4 }}>
        <h1 className="title" style={{ margin: 0 }}>{head}</h1>
        <p style={{ fontSize: 16, fontWeight: 800, lineHeight: 1.55 }}>{rest.join(". ")}</p>
      </section>

      <div className="card dashed">
        <p style={{ fontSize: 14, fontWeight: 800, lineHeight: 1.55 }}>왜 하루 한 번이냐면요</p>
        <p style={{ fontSize: 13, fontWeight: 700, lineHeight: 1.6, color: "var(--muted-on-color)" }}>
          한 번 붙는 데 AI를 네 번 부르고, 그 값을 저희가 냅니다. 무료로 계속 열어 두려고 하루 한 번으로 묶어 뒀어요.
        </p>
      </div>

      <h2 className="label" style={{ marginTop: 4 }}>그동안 이런 걸 볼 수 있어요</h2>
      <a href="/archive" className="row-link">
        <span aria-hidden="true" style={{
          width: 42, height: 42, flexShrink: 0, border: "1px solid var(--line)", borderRadius: 999,
          background: "var(--paper)", display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          <Icon name="list" size={20} />
        </span>
        <span style={{ flexGrow: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 3 }}>
          <span style={{ fontSize: 16, fontWeight: 800 }}>남들은 뭐라고 답했나</span>
          <span className="note">공개에 동의한 토론만 모았어요</span>
        </span>
        <Icon name="next" size={18} />
      </a>

      <span className="grow" />
      <p className="note" style={{ textAlign: "center" }}>
        <Icon name="clock" size={14} /> 자정에 새로 채워져요
      </p>
    </main>
  );
}
